    <app-navbar />
    <section class="pt-16">
        <div class="al-left">
            <app-sidebar />
        </div>
        <div class="al-right p-10">
                <router-outlet></router-outlet>
        </div>
    </section>
